import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import Logo from "../components/Logo";
import { title, subtitle, address } from "../data/database";
import { colour } from "../data/colour";

const Header = () => {
  const isTab = useMediaQuery("(max-width:770px)");
  // const [activeMenu, setActiveMenu] = useState(null);

  // const toggleMenu = (menu) => {
  //   setActiveMenu(activeMenu === menu ? null : menu);
  // };

  return (
    <Box
      sx={{
        width: "100dvw",
        maxWidth: "1000px",
        position: "sticky",
        top: 0,
        zIndex: 1003,
        margin: "auto",
        backgroundColor: "rgb(25, 25, 25)",
      }}
    >
      <Box
        sx={{
          color: "white",
          display: "flex",
          alignItems: "center",
          margin: "auto",
          width: "90%",
          padding: "0.75rem 0",
        }}
      >
        <Logo height={60} />
        <Box sx={{ marginLeft: "0.5rem" }}>
          <Box sx={{ fontSize: "1.5rem", marginBottom: 0 }}>{title}</Box>
          <Box
            sx={{ fontSize: "0.75rem", color: colour.accent, marginTop: -1 }}
          >
            {subtitle}
          </Box>
          <Box sx={{ fontSize: isTab ? "0.65rem" : "0.75rem" }}>{address}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
